import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { StyledLegend } from '@components/SectionBlocks/Testshowcase/Legend';

export const ContentHeader = styled(Text)`
  margin: 0 0 ${spacing.space16};
`;
export const Caption = styled(Text)`
  font-style: italic;
  margin: 0 0 ${spacing.space48};
  width: max-content;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.5;
  @media (max-width: ${breakpoints.l}) {
    margin-bottom: ${spacing.space40};
    width: calc(100vw - 48px);
  }
`;
export const ElevationChartContainer = styled.figure`
  width: 100%;
  margin: 0;
  @media (max-width: ${breakpoints.s}) {
    margin: 0 -${spacing.space24};
    width: calc(100% + 2 * ${spacing.space24});
    ${StyledLegend} {
      margin-left: ${spacing.space24};
    }
  }
`;
export const ScrollAnchorTag = styled.div`
  scroll-margin: 100px;
`;
export const PaywallWrapper = styled.div`
  margin-top: ${spacing.space64};
`;
